import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Alert,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledTooltip,
  Table
} from "reactstrap";
import Switch from "react-switch"
import classnames from "classnames";
import SweetAlert from "react-bootstrap-sweetalert"
import Select from "react-select";
import Dropzone from "react-dropzone";
import { useSelector } from "react-redux";
// Redux
import { withRouter, Link } from "react-router-dom";


// Editable
import BootstrapTable from "react-bootstrap-table-next"
import cellEditFactory from "react-bootstrap-table2-editor"
// availity-reactstrap-validation
import {
  AvForm,
  AvField,AvRadioGroup,AvRadio
} from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import { Fn_DisplayData, Fn_AddEditData, Fn_FillListData, Fn_ChangeStateValue } from "../../store/functions";

export const DateString = (dd) =>{

let d1 =  dd.replace('-', '');
let d2 = d1.replace('-', '');

return d2;

}

class AddEdit_Voucher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      
      formData: {},
       activeTab: 1,
       passedSteps: [1],
       BrowseImage1 : '',
       BrowseImage2 : '',
       UserImage : '',
       Signature : '',
      //dropdowns
      membershipType: [],
      maritalStatus: [],
      bloodGroup: [],
      gender: [],
      education: [],
      profession: [],
      relationShip: [],
      nationality: [],
      typeofRegCert: [],
      memberid : 0,
      name : "",
      email : "",
      aid : 0,
      fo3 : false,
      Gender : 0,
      MaritalStatus : 0,
      success_msg : false,
      F_MISScheme : 0,
      IsOvertime : false,
      EmpBasic : [],
             LedgerCustomers: [],
       FinancialYearMaster: [],
       VoucherType : [
         {
           value: 1,
           label: "Credit"
         },
         {
           value: 2,
           label: "Debit"
         }
       ],
       // Grid system state
       gridRows: [
         {
           id: 1,
           ledgerId: null,
           voucherTypeId: null,
           financialYearId: null,
           amount: ""
         }
       ]
    };
    this.obj = this;
    this.formTitle = "Voucher";
    this.breadCrumbTitle = "Voucher";
    this.breadCrumbItem = "Add " + this.formTitle;
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/Voucher";
    this.API_URL_SAVE = API_WEB_URLS.Voucher + "/0/token";
    this.pushFormName = "/City";
    this.rtPage_Print = "/membersynopsisprint";

    //Event Binding
    this.btnSave_onClick = this.btnSave_onClick.bind(this);
    this.btnCancel_onClick = this.btnCancel_onClick.bind(this);
    this.btnGoBack_onClick = this.btnGoBack_onClick.bind(this);
    this.addRow = this.addRow.bind(this);
    this.addRowAfter = this.addRowAfter.bind(this);
    this.removeRow = this.removeRow.bind(this);
    this.handleGridChange = this.handleGridChange.bind(this);
    this.clearAllFields = this.clearAllFields.bind(this);
    this.calculateTotalAmount = this.calculateTotalAmount.bind(this);
  }

  componentDidMount() {

    const obj = JSON.parse( sessionStorage.getItem("authUser"));
    this.setState({ name: obj.username, email: obj.email, aid: obj.uid , role:obj.role });
 
    //Filling DropDowns
    Fn_FillListData(this.obj, "LedgerCustomers", API_WEB_URLS.MASTER + "/0/token/LedgerCustomers/Id/0");
    Fn_FillListData(this.obj, "FinancialYearMaster", API_WEB_URLS.MASTER + "/0/token/FinancialYearMaster/Id/0");
       // Fn_FillListData(this.obj, "membershipType", API_WEB_URLS.MASTER + "/0/token/MembershipType/Id/0");

    const { id } = this.props.match.params;
    if (id) {
      this.setState({ id: id });
      this.breadCrumbItem = "Edit " + this.formTitle;
      Fn_DisplayData(this.obj, id, this.API_URL + "/Id");
    } else {
      this.setState({ id: 0 });
    }   
  }

btnSave_onClick(event, formData) {
   
   let vformData = new FormData();
   
       // Transform grid data with proper field naming
    const transformedGridData = this.state.gridRows.map(row => ({
      id: row.id,
      F_LedgerMaster: row.ledgerId,
      F_FinancialYearMaster: row.financialYearId,
      VoucherType: row.voucherTypeId,
      Amount: row.amount
    }));
   
   // Add grid data as JSON string
   vformData.append("Data", JSON.stringify(transformedGridData));
   vformData.append("UserId", this.state.aid || 0);

  

     Fn_AddEditData(this.obj, { arguList: { id: 0, formData: vformData } }, this.API_URL_SAVE, this.pushFormName, true, "memberid");
  
}


btnGoBack_onClick = event => {
  event.preventDefault();
  //this.props.history.goBack();
  this.props.history.push(this.pushFormName);
};

  btnCancel_onClick = event => {
    event.preventDefault();
    //this.props.history.goBack();
    this.props.history.push(this.pushFormName);
  };

     addRow = () => {
     const newRow = {
       id: this.state.gridRows.length + 1,
       ledgerId: null,
       voucherTypeId: null,
       financialYearId: null,
       amount: ""
     };
     this.setState(prevState => ({
       gridRows: [...prevState.gridRows, newRow]
     }));
   };

   addRowAfter = (rowId) => {
     const newRow = {
       id: this.state.gridRows.length + 1,
       ledgerId: null,
       voucherTypeId: null,
       financialYearId: null,
       amount: ""
     };
     this.setState(prevState => {
       const rowIndex = prevState.gridRows.findIndex(row => row.id === rowId);
       const newGridRows = [...prevState.gridRows];
       newGridRows.splice(rowIndex + 1, 0, newRow);
       return { gridRows: newGridRows };
     });
   };

     removeRow = (rowId) => {
     this.setState(prevState => {
       const newGridRows = prevState.gridRows.filter(row => row.id !== rowId);
       // Ensure at least one row remains
       if (newGridRows.length === 0) {
         return {
           gridRows: [{
             id: 1,
             ledgerId: null,
             voucherTypeId: null,
             financialYearId: null,
             amount: ""
           }]
         };
       }
       return { gridRows: newGridRows };
     });
   };

  handleGridChange = (rowId, field, value) => {
    this.setState(prevState => ({
      gridRows: prevState.gridRows.map(row => 
        row.id === rowId ? { ...row, [field]: value } : row
      )
    }));
  };

     clearAllFields = () => {
     this.setState({
       formData: {},
       gridRows: [
         {
           id: 1,
           ledgerId: null,
           voucherTypeId: null,
           financialYearId: null,
           amount: ""
         }
       ]
     });
   };

   calculateTotalAmount = () => {
     return this.state.gridRows.reduce((total, row) => {
       const amount = parseFloat(row.amount) || 0;
       return total + amount;
     }, 0).toFixed(2);
   };

  render() {   
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={this.breadCrumbTitle}
              breadcrumbItem={this.breadCrumbItem}
            />
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    {/* <h4 className="card-title mb-4">Basic Wizard</h4> */}
                    <div className="wizard clearfix">
                     <div className="content clearfix">
                       <AvForm className="needs-validation" onValidSubmit={this.btnSave_onClick}>
                          <TabContent activeTab={this.state.activeTab} className="body">
                            <TabPane tabId={1}>
                                                                 <Row>
                                   <Col lg="12">
                                     <Card>
                                       <CardBody>
                                         <div className="d-flex justify-content-end">
                                           <h4 className="text-primary mb-0">
                                             Total Amount: ₹ {this.calculateTotalAmount()}
                                           </h4>
                                         </div>
                                       </CardBody>
                                     </Card>
                                   </Col>                                 
                                 </Row>

                                {/* Grid System */}
                                <Row className="mt-4">
                                  <Col lg="12">
                                    <Card>
                                      <CardBody>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                          <h4 className="card-title mb-0">Voucher Details</h4>
                                          <div>
                                            <Button
                                              type="button"
                                              color="success"
                                              className="mr-2"
                                              onClick={this.addRow}
                                            >
                                              <i className="fas fa-plus"></i> Add Row
                                            </Button>
                                            <Button
                                              type="button"
                                              color="warning"
                                              onClick={this.clearAllFields}
                                            >
                                              <i className="fas fa-eraser"></i> Clear All
                                            </Button>
                                          </div>
                                        </div>
                                        
                                        <div className="table-responsive" style={{ overflow: 'visible' }}>
                                          <Table className="table table-bordered table-striped" style={{ position: 'relative' }}>
                                                                                         <thead className="thead-light">
                                               <tr>
                                                 <th width="5%">#</th>
                                                 <th width="25%">Ledger Master</th>
                                                 <th width="25%">Financial Year</th>
                                                 <th width="20%">Voucher Type</th>
                                                 <th width="20%">Amount</th>
                                                 <th width="5%">Action</th>
                                               </tr>
                                             </thead>
                                            <tbody>
                                              {this.state.gridRows.map((row, index) => (
                                                <tr key={row.id}>
                                                                                                     <td>{index + 1}</td>
                                                   <td style={{ position: 'relative', minHeight: '60px' }}>
                                                     <Select
                                                       value={this.state.LedgerCustomers.map(item => ({
                                                         value: item.Id,
                                                         label: item.Name
                                                       })).find(option => option.value === row.ledgerId) || null}
                                                       onChange={(selectedOption) => this.handleGridChange(row.id, 'ledgerId', selectedOption ? selectedOption.value : null)}
                                                       options={this.state.LedgerCustomers.map(item => ({
                                                         value: item.Id,
                                                         label: item.Name
                                                       }))}
                                                       placeholder="Select Ledger"
                                                       isClearable
                                                       className="react-select"
                                                       styles={{
                                                         menu: (provided) => ({
                                                           ...provided,
                                                           zIndex: 9999,
                                                           position: 'absolute'
                                                         }),
                                                         container: (provided) => ({
                                                           ...provided,
                                                           zIndex: 9999
                                                         })
                                                       }}
                                                     />
                                                   </td>
                                                   <td>
                                                     <select
                                                       value={row.financialYearId || ''}
                                                       onChange={(e) => this.handleGridChange(row.id, 'financialYearId', e.target.value ? parseInt(e.target.value) : null)}
                                                       className="form-control"
                                                     >
                                                       <option value="">Select Year</option>
                                                       {this.state.FinancialYearMaster.map((option) => (
                                                         <option key={option.Id} value={option.Id}>
                                                           {option.Name}
                                                         </option>
                                                       ))}
                                                     </select>
                                                   </td>
                                                   <td>
                                                     <select
                                                       value={row.voucherTypeId || ''}
                                                       onChange={(e) => this.handleGridChange(row.id, 'voucherTypeId', e.target.value ? parseInt(e.target.value) : null)}
                                                       className="form-control"
                                                     >
                                                       <option value="">Select Type</option>
                                                       {this.state.VoucherType.map((option) => (
                                                         <option key={option.value} value={option.value}>
                                                           {option.label}
                                                         </option>
                                                       ))}
                                                     </select>
                                                   </td>
                                                   <td>
                                                     <Input
                                                       type="number"
                                                       value={row.amount}
                                                       onChange={(e) => this.handleGridChange(row.id, 'amount', e.target.value)}
                                                       placeholder="Enter Amount"
                                                       className="form-control"
                                                     />
                                                   </td>
                                                                                                     <td>
                                                     <div className="d-flex justify-content-center">
                                                       <Button
                                                         type="button"
                                                         color="success"
                                                         size="sm"
                                                         className="mr-1"
                                                         onClick={() => this.addRowAfter(row.id)}
                                                       >
                                                         <i className="fas fa-plus"></i>
                                                       </Button>
                                                       <Button
                                                         type="button"
                                                         color="danger"
                                                         size="sm"
                                                         onClick={() => this.removeRow(row.id)}
                                                       >
                                                         <i className="fas fa-minus"></i>
                                                       </Button>
                                                     </div>
                                                   </td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </Table>
                                        </div>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                </Row>
                                          
                            </TabPane>                                                  
                          </TabContent>
                          <div>
                          <Button
                          type="submit"
                          color="primary"
                          className="mr-1 waves-effect waves-light"
                        >
                          Save
                        </Button>
                        
                        &nbsp; 

                        <Button
                          type="button"
                          color="primary"
                          className="mr-1 waves-effect waves-light"
                          onClick={this.btnGoBack_onClick}
                        >
                          Go Back
                        </Button>
                        
                          </div>
                        </AvForm>
                      </div>                    
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default compose(container)(AddEdit_Voucher);